// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  selectPatientImageChangeRequestsInStore,
  selectPatientImageChangeRequestsPageLoading,
  selectPatientImageChangeRequestShowInitWaitingMessage,
} from '../_selectors/patient-image-change-request.selectors';

export class PatientsImageChangeRequestsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectPatientImageChangeRequestsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectPatientImageChangeRequestShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectPatientImageChangeRequestsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
